import React, { FC } from 'react';
import { CustomInputProps } from './CustomInputProps';
import FormField from '@ingka/form-field';
import InputField from '@ingka/input-field';
import { Controller, useFormContext } from 'react-hook-form';
import { positiveOnChange } from '../../utils/validation';
import { returnDisabledStatus } from '../../utils/fieldEditingRules';

const CustomInput: FC<CustomInputProps> = ({
  name,
  label,
  currencySymbol,
  dataTestID,
  type = 'text',
  required,
  helperText = '',
  disabled = false,
  defaultValue = '',
  customOnChange = () => {
    // do nothing
  },
  disabledOnAll = true,
}) => {
  const {
    control,
    watch,
    formState: { errors },
  } = useFormContext();
  const disabledFields = watch('disabledFields');
  return (
    <Controller
      render={({ field: { onChange, value } }) => (
        <FormField
          valid={!errors[name]}
          shouldValidate={!!errors[name]}
          className={'green-validation-disabled'}
          validation={{
            id: `validation-message-${name}`,
            msg: errors[name]?.message,
            type: 'error',
          }}
          fieldHelper={{
            id: 'input-helper',
            msg: helperText,
            type: 'text',
          }}
          style={{ marginBottom: 0 }}
        >
          {(
            required && !value
              ? false
              : disabled ||
                returnDisabledStatus(disabledFields, name, disabledOnAll)
          ) ? (
            <InputField
              className={'read-only-input'}
              id={dataTestID}
              type={'text'}
              label={`${label}${required ? ' *' : ''}`}
              value={value ?? defaultValue}
              data-testid={dataTestID}
              readOnly
            />
          ) : (
            <InputField
              prefixLabel={currencySymbol ? currencySymbol : ''}
              id={name}
              data-testid={dataTestID}
              label={`${label}${required ? ' *' : ''}`}
              type={type}
              onChange={(e) => {
                if (type === 'number') {
                  positiveOnChange(e, () => {
                    onChange(e);
                    customOnChange();
                  });
                } else {
                  onChange(e);
                  customOnChange();
                }
              }}
              value={value ? value : ''}
              placeholder={defaultValue}
            />
          )}
        </FormField>
      )}
      control={control}
      name={name}
    />
  );
};

export default CustomInput;
